<template>
  <b-container>
    <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.title_font.replace(/'/g, '')" hidden></FontPicker>
    <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.body_font.replace(/'/g, '')" hidden></FontPicker>

    <b-modal id="modal-1" @ok="update_custom_style">
      <b-form-group label="Title font" label-cols="4">
        <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.title_font.replace(/'/g, '')" @change="(f) => site.style.title_font = f.family"></FontPicker>
      </b-form-group>

      <b-form-group label="Title weight" label-cols="4">
        <b-form-select v-model="site.style.title_weight" :options="['300','400', '500', '600', '700', '800', '900']"></b-form-select>
      </b-form-group>

      <b-form-group label="Body font" label-cols="4">
        <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.body_font.replace(/'/g, '')" @change="(f) => site.style.body_font = f.family"></FontPicker>
      </b-form-group>
    </b-modal>

    <b-card-group deck>
      <b-card v-for="(style, key) in constants.styles" :key="key" :class="{'palette': true, 'palette_selected': site.style.key == key}" @click="update_style(style)">
        <h2 class="style-header" :style="`font-family: ${style.title_font}; font-weight: ${style.title_weight}`">{{key | capitalise}}</h2>
        <p class="style-subtext" :style="`font-family: ${style.body_font}`">{{style.description}}</p>
      </b-card>

      <b-card :class="{'palette': true, 'palette_selected': site.style.key == 'custom'}" v-b-modal.modal-1 v-if="!hide_custom">
        <h2 class="style-header" :style="`font-family: ${site.style.title_font}; font-weight: ${site.style.title_weight}`">Custom</h2>
        <p class="style-subtext" :style="`font-family: ${site.style.body_font}`">Custom fonts to match your own style</p>
      </b-card>
    </b-card-group>
  </b-container>
</template>

<script>

import { db, serverTimestamp, FieldValue } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import FontPicker from 'font-picker-vue'

export default {
  name: 'styles',
  props: ['profile', 'site', 'hide_custom'],
  components: {FontPicker},
  mixins: [ItemMixin],
  methods: {
    async update_custom_style() {
      await db.collection('site').doc(this.site.id).update({
        style: {key: 'custom', title_font: this.site.style.title_font, title_font_fallback: 'sans-serif', title_weight: this.site.style.title_weight, body_font_fallback: 'sans-serif', body_font: this.site.style.body_font}
      })
      await this.after_write()
    },
    async update_style(style) {
      await db.collection('site').doc(this.site.id).update({
        style: style
      })
      this.site.style = style
      await this.after_write()
    },
    async after_write() {
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    }
  },
}
</script>

<style scoped>
.style-header {
  font-weight: bold;
}

.palette_selected {
  background: #EFEFEF;
}

.palette:hover {
  background: #EFEFEF;
}

.palette {
  min-width: 14em;
  margin-bottom: 1em !important;
  text-align: center;
  cursor: pointer;
}

.colour-subtext {
  margin: 1em 1em;
}
</style>
